import { render, staticRenderFns } from "./unionDetails.vue?vue&type=template&id=8c3721c4&scoped=true&"
import script from "./unionDetails.vue?vue&type=script&lang=js&"
export * from "./unionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3721c4",
  null
  
)

export default component.exports